import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
const { JWT_SECRET } = process.env;


export default function Profile({ setUser, setIsLoggedIn, token, setToken, users }){
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);

    useEffect(() => {
      if (!token) {
        return;
      }
      setUserName(localStorage.getItem("localUser"));
      getUser();
    }, []);
    // setUserName(localStorage.getItem("localUser"));

 
    async function getUser() {
      try {
        const response = await fetch("http://localhost:4000/api/users/me", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
      let result = await response.json();
      console.log(result)
      return result;
      } catch (err) {
        console.log(err);
      }
    }

    // getUser();

    const navigate = useNavigate();

    function logout() {
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        setIsLoggedIn(false);
        setToken(null);
        navigate("/login");              
      }
  
    return (
      <div className="profile-container">
        <div className="profile-content">
          <h1 className="profile-title">Profile</h1>
          <div className="profile-info">
            <h2 className="profile-username">Username: {userName}</h2>
            <button className="profile-logout-btn" onClick={logout}>
              Logout
            </button>
          </div>
        </div>
      </div>
    );
}; 